import { LoginResult, PasswordResetResult, SignUpResult } from "@/domain/repository/AuthRepository";
import { authState } from "rxfire/auth";
import { map } from "rxjs/operators";
export class AuthRepositoryImpl {
    constructor(auth) {
        this.auth = auth;
        this.userId = authState(this.auth).pipe(map(user => user === null || user === void 0 ? void 0 : user.uid));
    }
    async login(email, password) {
        try {
            await this.auth.signInWithEmailAndPassword(email, password);
        }
        catch (e) {
            if (e.code == "auth/user-not-found")
                return LoginResult.UserNotFound;
            if (e.code == "auth/wrong-password")
                return LoginResult.WrongPassword;
            if (e.code == "auth/too-many-requests")
                return LoginResult.TooManyAttempts;
            throw e;
        }
        return LoginResult.Success;
    }
    async signUp(email, password) {
        try {
            const credential = await this.auth.createUserWithEmailAndPassword(email, password);
            return new SignUpResult.Success(credential.user.uid);
        }
        catch (e) {
            if (e.code == "auth/email-already-in-use")
                return SignUpResult.EmailTaken;
            throw e;
        }
    }
    async sendPasswordResetEmail(email) {
        try {
            await this.auth.sendPasswordResetEmail(email);
        }
        catch (error) {
            return getPasswordResetResultFromError(error);
        }
        return PasswordResetResult.Success;
    }
    logout() {
        return this.auth.signOut();
    }
}
function getPasswordResetResultFromError(error) {
    if (error.code == "auth/user-not-found")
        return PasswordResetResult.Success;
    return PasswordResetResult.InternalError;
}
